import { TZDate } from "@date-fns/tz";

export function pluralise(count, singular, plural = `${singular}s`) {
  return `${count} ${count === 1 ? singular : plural}`;
}

export function assembleDateTime(date, time) {
  if (!date || !time) {
    return null;
  }

  const [hours, minutes, seconds] = time.split(":").map((t) => parseInt(t, 10));

  if (typeof date === "string") {
    const parts = date.split(/[/-]/).map((part) => parseInt(part, 10));
    const [year, month, day] = parts;

    if ([year, month, day, hours, minutes, seconds].some(Number.isNaN)) {
      return null;
    }

    return new TZDate(
      year,
      month - 1,
      day,
      hours,
      minutes,
      seconds,
      "Pacific/Auckland",
    ).getTime();
  }

  if (
    typeof date?.getFullYear !== "function" ||
    typeof date?.getMonth !== "function" ||
    typeof date?.getDate !== "function" ||
    [hours, minutes, seconds].some(Number.isNaN)
  ) {
    return null;
  }

  return new TZDate(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    hours,
    minutes,
    seconds,
    "Pacific/Auckland",
  ).getTime();
}

export function getNextStop(
  startDate,
  stops,
  currentTimestamp,
  delay,
  gracePeriod = 4,
) {
  if (!Array.isArray(stops) || stops.length === 0) {
    return null;
  }

  let nextStop = null;

  for (let i = 0; i < stops.length; i++) {
    const stop = stops[i];

    const scheduledTimestamp = assembleDateTime(startDate, stop.departure_time);
    if (!Number.isFinite(scheduledTimestamp)) {
      continue;
    }
    const adjustedTime = scheduledTimestamp + delay * 1000;

    if (adjustedTime >= currentTimestamp - gracePeriod * 1000) {
      nextStop = {
        stopOrder: i,
        stopId: stop.stop_id,
        stopName: stop.stop_name,
        adjustedTime,
      };
      break;
    }
  }

  if (!nextStop && stops.length > 0) {
    const lastStop = stops[stops.length - 1];
    const lastStopScheduledTimestamp = assembleDateTime(
      startDate,
      lastStop?.departure_time,
    );

    if (!Number.isFinite(lastStopScheduledTimestamp)) {
      return null;
    }

    nextStop = {
      stopOrder: stops.length,
      stopId: lastStop.stop_id,
      stopName: lastStop.stop_name,
      adjustedTime: lastStopScheduledTimestamp + delay * 1000,
    };
  }

  return nextStop;
}

export function timeTidyPlus(
  scheduledTimestamp,
  currentTimeString,
  delay = 0,
) {
  const adjustedTime = scheduledTimestamp + delay * 1000;
  const currentTime = Date.parse(currentTimeString);
  return {
    time: new Date(adjustedTime).toLocaleTimeString("en-AU", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "Pacific/Auckland",
    }),
    seconds: Math.round((adjustedTime - currentTime) / 1000),
  };
}

export function formatDelayMessage(delayMinutes, minuteText = "minute") {
  const absMinutes = Math.abs(delayMinutes);
  const timeStatus = delayMinutes > 0 ? "late" : "early";

  if (delayMinutes === 0) {
    return "On time";
  }

  return `${pluralise(absMinutes, minuteText)} ${timeStatus}`;
}
